export default __webpack_public_path__ + "1e1c2aeee0fb74505fce3a4693a45226.png";